import moment from "moment";
import { convertFromRaw } from "draft-js";
import Cognito from "api/cognito/Cognito";

import { IEventsForm } from "../api";
import { slugifyWord } from "../helpers/globalFunctions";
import { CATEGORIES } from "../constants/categories";
import { ContentStatusTypes } from "../api/api";
import { uploadImageFromFile } from "../api/ImageApi";

export default async function EventsPostModel(
  form: IEventsForm,
): Promise<IEventsForm> {
  const {
    id,
    title,
    description,
    category,
    subCategories,
    countries,
    address,
    imagePointer,
    imageUrl,
    authorType,
    author,
    creator,
    creatorName,
    organizationId,
    anotherAuthor,
    type,
    createdAt,
    toBePostedAt,
    dateFrom,
    dateTo,
    highlighted,
    highlightedInCountry,
    show,
    imageAuthor,
    customLabel,
    exclusive,
    source,
    slug,
    displayInHomePage,
    online,
    organizationInfo,
    homepageRank,
  } = form;

  let newImageUrl = imageUrl;
  if (imagePointer) {
    const token = Cognito.getIdTokenFromStorage();
    newImageUrl = await uploadImageFromFile(token, imagePointer);
  }
  const realSlug = slug !== "" ? slug : slugifyWord(title);
  const seoDescription = description
    ? convertFromRaw(description).getPlainText().slice(0, 320)
    : "";

  const newSubCategories = subCategories ? [...subCategories] : [];

  // Due to elastic search category must also be placed in subcategories.
  const allCategories = Object.values(CATEGORIES);
  // eslint-disable-next-line no-unused-expressions
  subCategories?.forEach((sub, idx) => {
    if (allCategories.find((cat) => sub === cat))
      newSubCategories.splice(idx, 1);
  });

  if (category) newSubCategories.push(category);

  const isItToBePosted = toBePostedAt ? moment().isBefore(toBePostedAt) : false;
  return {
    id,
    slug: realSlug,
    imageUrl: newImageUrl,
    imageAuthor,
    createdAt,
    toBePostedAt: toBePostedAt || moment(),
    dateTo,
    dateFrom,
    title,
    countries,
    address,
    description,
    category,
    subCategories: newSubCategories,
    seoDescription,
    authorType,
    author,
    creator,
    creatorName,
    organizationId,
    anotherAuthor,
    customLabel,
    highlighted,
    highlightedInCountry,
    show,
    exclusive,
    type,
    source,
    displayInHomePage,
    online,
    status: isItToBePosted
      ? ContentStatusTypes.toBePosted
      : ContentStatusTypes.active,
    organizationInfo,
    homepageRank,
  };
}
